import React from 'react';
import { useMutation } from 'react-fetching-library';
import { getCustomFormCalculatorData } from '../../services/request';

export default function CustomCalculator({ field, formik }) {
  const [value, setValue] = React.useState('');
  const { mutate } = useMutation(getCustomFormCalculatorData);
  const dependsOn = field.depends_on.trim().replaceAll('\n', '')
    .split(' ');

  React.useEffect(async () => {
    const { error, payload } = await mutate({ ...formik.values, field_name: field.name });

    if (!error) {
      setValue(payload.text);
    } else {
      setValue('');
    }
  }, dependsOn.map(value => formik.values[value]));

  return <div dangerouslySetInnerHTML={{ __html: value }} style={{ marginTop: '20px', color: '2A88C1' }}></div>;
};
